export const AscImg = "/images/asc.png";
export const DescImg = "/images/desc.png";
